import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, TrendingUp, DollarSign, Calendar } from 'lucide-react';
import { services } from '../data/mockData';
import { StatCard } from '../components/ui/StatCard';
import { Button } from '../components/ui/Button';
export function BillingDashboard() {
  const navigate = useNavigate();
  const billingServices = services.filter(s => s.has_billing && s.row_status === 'active');
  return <div className="space-y-6" data-id="element-135">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-136">
        <div data-id="element-137">
          <h1 className="text-2xl font-bold text-slate-800" data-id="element-138">
            Billing Dashboard
          </h1>
          <p className="text-slate-500" data-id="element-139">Revenue & Service Delivery Overview</p>
        </div>

        <div className="flex items-center space-x-2 bg-white p-2 rounded-lg border border-slate-200 shadow-sm" data-id="element-140">
          <Calendar className="w-4 h-4 text-slate-400 ml-2" data-id="element-141" />
          <input type="date" className="text-sm border-none focus:ring-0 text-slate-600" data-id="element-142" />
          <span className="text-slate-400" data-id="element-143">-</span>
          <input type="date" className="text-sm border-none focus:ring-0 text-slate-600" data-id="element-144" />
          <Button size="sm" data-id="element-145">Filter</Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-146">
        {billingServices.map(service => <div key={service.id} onClick={() => navigate(`/billing/${service.uuid}`)} className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 cursor-pointer hover:shadow-md hover:border-blue-200 transition-all group" data-id="element-147">
            <div className="flex justify-between items-start mb-4" data-id="element-148">
              <div className="p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors" data-id="element-149">
                <FileText className="w-6 h-6 text-blue-600" data-id="element-150" />
              </div>
              <div className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-bold" data-id="element-151">
                Live
              </div>
            </div>

            <h3 className="text-lg font-bold text-slate-800 mb-1" data-id="element-152">
              {service.name_en}
            </h3>
            <p className="text-sm text-slate-500 mb-6" data-id="element-153">{service.name}</p>

            <div className="grid grid-cols-2 gap-4 border-t border-slate-100 pt-4" data-id="element-154">
              <div data-id="element-155">
                <p className="text-xs text-slate-500 mb-1" data-id="element-156">Total Revenue</p>
                <p className="text-lg font-bold text-slate-800" data-id="element-157">
                  ৳{(Math.random() * 1000000).toFixed(0)}
                </p>
              </div>
              <div data-id="element-158">
                <p className="text-xs text-slate-500 mb-1" data-id="element-159">Services Provided</p>
                <p className="text-lg font-bold text-slate-800" data-id="element-160">
                  {(Math.random() * 5000).toFixed(0)}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}